import { EcommerceAPI } from "../Client";
import { appendProcessedFiles } from "../../../utils/imageUploadProcessor";

export const getProductCategoriesApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/product/categories`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/product/categories`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createProductSubCategoryApi = async (payload) => {
  try {
    const { parentId = payload?.categoryId, categoryId, ...body } = payload || {};
    const response = await EcommerceAPI.post(
      `/product/sub/categories?parentId=${parentId ?? ""}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createProductSubSubCategoryApi = async (payload) => {
  try {
    const { parentId = payload?.categoryId, categoryId, ...body } = payload || {};
    const response = await EcommerceAPI.post(
      `/product/sub-sub/categories?parentId=${parentId ?? ""}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompleteProductCategoriesApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/product/complete/categories`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProductChildCategoriesApi = async (parentId) => {
  try {
    const response = await EcommerceAPI.get(`/product/child/categories?parentId=${parentId ?? ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/product/categories`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductCategoryPriorityApi = async ({ categoryId, priority }) =>
  EcommerceAPI.put(`/product/category/priority`, null, {
    params: { categoryId, priority },
  });

export const deleteProductCategoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/product/categories?id=${payload?.id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductCategoryImageApi = async (payload) => {
  return EcommerceAPI.delete(`/product/category/image`, {
    params: { id: payload.id },
  });
};

export const productCategoryFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();
    //compress to png
    await appendProcessedFiles(formData, "file", payload.files, {
      mimeType: "image/png",
    });

    const response = await EcommerceAPI.post(`/product/category/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
